import { render, staticRenderFns } from "./Loyalty.vue?vue&type=template&id=7ecb91fd&lang=pug&"
import script from "./Loyalty.vue?vue&type=script&lang=js&"
export * from "./Loyalty.vue?vue&type=script&lang=js&"
import style0 from "./Loyalty.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports